import styled from "styled-components"
import { motion } from "framer-motion"

export const HeaderNav = styled(motion.div)`
  height: 0px;
  width: 100%;
  position: absolute;
  top: 72px;
  right: 0;
  left: 0;
  z-index: 1;
`
export const Logo = styled.div`
  a {
    font-size: 2.8rem;
    font-weight: 800;
    color: ${props => props.theme.text};
  }

  span {
    height: 1.6rem;
    width: 1.6rem;
    background-color: ${props => props.theme.red};
    margin: 0 2px 0 4px;
    border-radius: 100%;
    display: inline-block;
    position: relative;
    bottom: 2px;
  }
`

export const Menu = styled.div`
  button {
    transform-origin: center;
    border: none;
    padding: 2rem;
    background: none;
    outline: none;

    span {
      width: 3.6rem;
      height: 8px;
      display: block;
      background-color: ${props => props.theme.text};
      margin: 8px;
    }
  }
`
